import { render, staticRenderFns } from "./ManageChecklistItem.vue?vue&type=template&id=848fabe4&scoped=true"
import script from "./ManageChecklistItem.vue?vue&type=script&lang=js"
export * from "./ManageChecklistItem.vue?vue&type=script&lang=js"
import style0 from "./ManageChecklistItem.vue?vue&type=style&index=0&id=848fabe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848fabe4",
  null
  
)

export default component.exports